import usePrivateAxios from "@/common/api/usePrivateAxios";
import { ErrorResponse } from "@/common/types/errorResponse";
import { useMutation } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { RejectFiscalDocumentValidationSchema } from "../schemas/rejectFiscalDocument.schema";

interface UseRejectFiscalDocument {
  id: string;
  onSuccess?: (response: AxiosResponse) => void;
  onError?: (error: ErrorResponse) => void;
}

const useBillingFiscalDocumentGroupRejectFiscalDocument = ({ id, onSuccess, onError }: UseRejectFiscalDocument) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['billingFiscalDocumentGroupRejectFiscalDocument', id],
    mutationFn: async (form: RejectFiscalDocumentValidationSchema) => {
      const payload = {
        fiscal_document_group: {
          fiscal_document_attributes: {
            rejection_reason: form.rejection_reason,
          },
        },
      };

      return await privateAxios.post(`/billing/fiscal_document_groups/${id}/reject_fiscal_document`, payload);
    },
    onSuccess,
    onError,
  });
};

export default useBillingFiscalDocumentGroupRejectFiscalDocument;
